import clientInvitationStatusEnum from '@/enums/client-invitation-status.enum'
import lang from '@/lang'
import { toast } from '@/modules/base/components/toast/toastConfig'
import useWebSocketEvent, { EventTypes } from '@/modules/webSocket'
import { fetchInvitingTenants } from '@/redux/ducks/collaboration/inviting'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const useInvites = (initialRefresh = false, showMessage = true) => {
  const [shallRefresh, setShallRefresh] = useState(initialRefresh)
  const collaborationInvites = useSelector(state => state.collaboration.inviting)
  const { isInitialized, data: invitingClients, isLoading } = collaborationInvites
  useWebSocketEvent([EventTypes.CONNECT, EventTypes.COLLABORATION_UPDATED], () => {
    dispatch(fetchInvitingTenants())
  })

  useWebSocketEvent(EventTypes.COLLABORATION_STATUS_CHANGED, ({ data }) => {
    const message = lang.tenant.collaboration[data.status] || (() => { return data.status })
    if (showMessage) {
      toast.showToast({
        message: message(data.name),
        type: data.status === clientInvitationStatusEnum.ACCEPTED ? 'success' : 'warning',
      })
    }
    dispatch(fetchInvitingTenants())
  })

  const dispatch = useDispatch()

  useEffect(() => {
    if (!isInitialized || shallRefresh === true) {
      setShallRefresh(false)
      dispatch(fetchInvitingTenants())
    }
  }, [isInitialized, shallRefresh])

  return {
    invitingClients,
    hasInvites: !!invitingClients.length,
    isLoading,
  }
}

export default useInvites
